"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("react");
var react_2 = require("@emotion/react");
var styles_1 = require("./styles");
var Text_1 = __importDefault(require("../Text"));
var constant_1 = require("../../constant");
var BreadcrumbItem = function (_a) {
    var children = _a.children, isActive = _a.isActive, props = __rest(_a, ["children", "isActive"]);
    var theme = react_2.useTheme();
    var styles = react_1.useMemo(function () { return styles_1.getBreadcrumbItemStyleConfig(theme); }, [theme]);
    return theme.name === constant_1.DESIGN_SYSTEM ? (react_2.jsx(Text_1.default.Body, __assign({ weight: "semibold", css: [
            styles.container,
            isActive ? styles.activeContainer : undefined,
        ] }, props), children)) : (react_2.jsx("span", __assign({ css: [
            styles.container,
            isActive ? styles.activeContainer : undefined,
        ] }, props), children));
};
exports.default = BreadcrumbItem;
